import { SectionOutput } from 'infrastructure/graphql/content/section/model/section.output';
import { Section } from 'phase/section/section';

export abstract class SectionConverterPort {
	public abstract sectionsAsEntities(
		outputs: SectionOutput[],
		phaseId: string
	): Section[];
}
